import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import jwt_decode from "jwt-decode";
import { throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { environment } from "../../environments/environment";
import { UserCategory } from "./schema";
import Swal from "sweetalert2";
import { newMenuItem } from "../sidebar/new-sidebar/configs/configs.component";

@Injectable({
  providedIn: "root",
})
export class DataService {
  BASEURL = environment.apiUrl;
  EVENT_BASEURL = environment.eventApiUrl;

  constructor(private http: HttpClient) {}

  getToken() {
    return localStorage.getItem("ectoken");
  }

  getDecodedToken() {
    const token = localStorage.getItem("ectoken");
    return jwt_decode(token);
  }

  setToken(token) {
    localStorage.setItem("ectoken", token);
  }

  removeToken() {
    localStorage.removeItem("ectoken");
  }

  getDeviceList() {
    return this.http.get(`${this.BASEURL}/device`).pipe(
      map((Response) => {
        return Response;
      }),
      catchError((errorRes) => {
        return throwError(errorRes);
      }),
    );
  }

  userRole() {
    const token: any = this.getDecodedToken();
    // console.log(token);

    if (token && token.ucategory) {
      if (
        token.ucategory.category_name?.toLowerCase() === UserCategory.Superadmin
      ) {
        return { type: UserCategory.Superadmin };
      } else if (
        token.ucategory.category_name?.toLowerCase() === UserCategory.Admin
      ) {
        // console.log('admin---->',token);
        return {
          type: UserCategory.Admin,
          plantId: token.plant_id,
          _id: token._id,
        };
      } else if (
        token.ucategory.category_name?.toLowerCase() === UserCategory.User
      ) {
        return {
          type: UserCategory.User,
          // deviceId: token.device._id,
          // device_id: token.device.device_id,
          // plantId: token.plant_id,
        };
      } else if (
        token.ucategory.category_name?.toLowerCase() === UserCategory.Partner
      ) {
        return {
          type: UserCategory.Partner,
          _id: token._id,
          // plantId: token.plant_id,
        };
      } else {
        return { type: false };
      }
    }
    return { type: false };
  }

  login(data) {
    return this.http.post(`${this.BASEURL}/user/login`, data).pipe(
      map((Response) => {
        return Response;
      }),
      catchError((errorRes) => {
        return throwError(errorRes);
      }),
    );
  }

  register(payload) {
    return this.http.post(`${this.BASEURL}/user/register`, payload).pipe(
      map((Response) => {
        return Response;
      }),
      catchError((errorRes) => {
        return throwError(errorRes);
      }),
    );
  }

  getUser() {
    return this.http.get(`${this.BASEURL}/user`).pipe(
      map((Response) => {
        return Response;
      }),
      catchError((errorRes) => {
        return throwError(errorRes);
      }),
    );
  }

  getUserById(id) {
    return this.http.get(`${this.BASEURL}/user/${id}`).pipe(
      map((Response) => {
        return Response;
      }),
      catchError((errorRes) => {
        return throwError(errorRes);
      }),
    );
  }

  getUserByType(id) {
    return this.http.get(`${this.BASEURL}/user-type/${id}`).pipe(
      map((Response) => {
        return Response;
      }),
      catchError((errorRes) => {
        return throwError(errorRes);
      }),
    );
  }

  getSidebar() {
    return this.http.get(`${this.BASEURL}/menu`);
  }

  getUserList(filter) {
    return this.http.get(`${this.BASEURL}/userlist?${filter}`).pipe(
      map((Response) => {
        return Response;
      }),
      catchError((errorRes) => {
        return throwError(errorRes);
      }),
    );
  }

  AddUserType(Payload) {
    return this.http.post(`${this.BASEURL}/user-type`, Payload).pipe(
      map((Response) => {
        return Response;
      }),
      catchError((errorRes) => {
        return throwError(errorRes);
      }),
    );
  }

  getUserTypeList() {
    return this.http.get(`${this.BASEURL}/user-type`).pipe(
      map((Response) => {
        return Response;
      }),
      catchError((errorRes) => {
        return throwError(errorRes);
      }),
    );
  }

  getmenu() {
    return this.http.get(`${this.BASEURL}/menu`).pipe(
      map((Response) => {
        return Response;
      }),
      catchError((errorRes) => {
        return throwError(errorRes);
      }),
    );
  }

  getUserCategoryList() {
    return this.http.get(`${this.BASEURL}/user-category`).pipe(
      map((Response) => {
        return Response;
      }),
      catchError((errorRes) => {
        return throwError(errorRes);
      }),
    );
  }

  getUserCategoryByID(id) {
    return this.http.get(`${this.BASEURL}/user-category/${id}`).pipe(
      map((Response) => {
        return Response;
      }),
      catchError((errorRes) => {
        return throwError(errorRes);
      }),
    );
  }

  editUser(id, payload) {
    return this.http.put(`${this.BASEURL}/user/${id}`, payload).pipe(
      map((Response) => {
        return Response;
      }),
      catchError((errorRes) => {
        return throwError(errorRes);
      }),
    );
  }

  changePassword(payload) {
    return this.http.post(`${this.BASEURL}/user/change-password`, payload).pipe(
      map((Response) => {
        return Response;
      }),
      catchError((errorRes) => {
        return throwError(errorRes);
      }),
    );
  }

  getPartner(filter) {
    return this.http.get(`${this.BASEURL}/user/filter?${filter}`).pipe(
      map((Response) => {
        return Response;
      }),
      catchError((errorRes) => {
        return throwError(errorRes);
      }),
    );
  }

  editPrevielege(id, payload) {
    return this.http.put(`${this.BASEURL}/user-type/${id}`, payload).pipe(
      map((Response) => {
        return Response;
      }),
      catchError((errorRes) => {
        return throwError(errorRes);
      }),
    );
  }

  requestTempPassword(data) {
    return this.http.post(`${this.BASEURL}/user/request-password`, data).pipe(
      map((Response) => {
        return Response;
      }),
      catchError((errorRes) => {
        return throwError(errorRes);
      }),
    );
  }

  recoverPassword(data) {
    return this.http.post(`${this.BASEURL}/user/recover-password`, data).pipe(
      map((Response) => {
        return Response;
      }),
      catchError((errorRes) => {
        return throwError(errorRes);
      }),
    );
  }

  getExponentData() {
    return this.http.get(`${this.BASEURL}/exp/results`).pipe(
      map((Response) => {
        return Response;
      }),
      catchError((errorRes) => {
        return throwError(errorRes);
      }),
    );
  }

  downloadExponentEpackEOLFile(fileName: string, testId: string) {
    const payload = { fileName };

    return this.http
      .post(
        `${this.EVENT_BASEURL}/epack_eol/download?testId=${testId}`,
        payload,
      )
      .pipe(
        map((Response) => {
          return Response;
        }),
        catchError((errorRes) => {
          return throwError(errorRes);
        }),
      );
  }

  getExponentDataBasedOnYear(year: number) {
    return this.http.get(`${this.BASEURL}/exp/results/${year}`).pipe(
      map((Response) => {
        return Response;
      }),
      catchError((errorRes) => {
        return throwError(errorRes);
      }),
    );
  }

  getAllUsers() {
    return this.http.get(`${this.BASEURL}/users/get-all-users`).pipe(
      map((Response) => {
        return Response;
      }),
      catchError((errorRes) => {
        return throwError(errorRes);
      }),
    );
  }

  getAllPartners() {
    return this.http.get(`${this.BASEURL}/users/get-all-partners`).pipe(
      map((Response) => {
        return Response;
      }),
      catchError((errorRes) => {
        return throwError(errorRes);
      }),
    );
  }

  getAllAdmins() {
    return this.http.get(`${this.BASEURL}/users/get-all-admins`).pipe(
      map((Response) => {
        return Response;
      }),
      catchError((errorRes) => {
        return throwError(errorRes);
      }),
    );
  }

  getAllUserTypes() {
    return this.http.get(`${this.BASEURL}/users/get-all-usertypes`).pipe(
      map((Response) => {
        return Response;
      }),
      catchError((errorRes) => {
        return throwError(errorRes);
      }),
    );
  }

  getUserCategoryIdByUserTypeId(userId: string) {
    return this.http
      .get(`${this.BASEURL}/users/get-usercategory-by-usertype/${userId}`)
      .pipe(
        map((Response) => {
          return Response;
        }),
        catchError((errorRes) => {
          return throwError(errorRes);
        }),
      );
  }

  getUserAdminByUserId(userId: string) {
    return this.http.get(`${this.BASEURL}/users/get-user-admin/${userId}`).pipe(
      map((Response) => {
        return Response;
      }),
      catchError((errorRes) => {
        return throwError(errorRes);
      }),
    );
  }

  registerUser(payload: any) {
    return this.http.post(`${this.BASEURL}/users/register-user`, payload).pipe(
      map((Response) => {
        return Response;
      }),
      catchError((errorRes) => {
        return throwError(errorRes);
      }),
    );
  }

  getUserInformation(userId: string) {
    return this.http.get(`${this.BASEURL}/users/get-user-info/${userId}`).pipe(
      map((Response) => {
        return Response;
      }),
      catchError((errorRes) => {
        return throwError(errorRes);
      }),
    );
  }

  updateUserInfo(payload: any, userId: string) {
    return this.http
      .post(`${this.BASEURL}/users/update-user-info/${userId}`, payload)
      .pipe(
        map((Response) => {
          return Response;
        }),
        catchError((errorRes) => {
          return throwError(errorRes);
        }),
      );
  }

  getpreTestPdfPresignedUrl(testId: string) {
    return this.http
      .post(`${this.EVENT_BASEURL}/epack_eol/pre-test-pdf-download`, { testId })
      .pipe(
        map((Response) => {
          return Response;
        }),
        catchError((errorRes) => {
          return throwError(errorRes);
        }),
      );
  }

  getNewSidebarMenuConfigs() {
    return this.http
      .get<{
        success: boolean;
        categories: {
          category: string;
          menus: string[];
        }[];
        data: newMenuItem[];
      }>(`${this.BASEURL}/new-menu/config/get-menu`, { observe: "response" })
      .pipe(
        map((Response) => {
          return Response;
        }),
        catchError((errorRes) => {
          return throwError(errorRes);
        }),
      );
  }

  getNewSidebarUserTypes() {
    return this.http
      .get<{
        success: boolean;
        data: {
          _id: string;
          name: string;
        }[];
      }>(`${this.BASEURL}/new-menu/config/get-user-types`, {
        observe: "response",
      })
      .pipe(
        map((Response) => {
          return Response;
        }),
        catchError((errorRes) => {
          return throwError(errorRes);
        }),
      );
  }

  getNewMenuUserAccess(userId: string) {
    return this.http
      .get<{
        success: boolean;
        new_menu_defaults: {
          category: string;
          menu: string;
          submenu: string;
        };
        data: Record<string, string[]>;
      }>(`${this.BASEURL}/new-menu/config/user-configs/${userId}`, {
        observe: "response",
      })
      .pipe(
        map((Response) => {
          return Response;
        }),
        catchError((errorRes) => {
          return throwError(errorRes);
        }),
      );
  }

  setNewMenuUserAccess(payload: {
    user_id: string;
    menu_access_list: Record<string, string[]>;
    new_menu_defaults: {
      category: string;
      menu: string;
      submenu: string;
    };
  }) {
    return this.http
      .put(`${this.BASEURL}/new-menu/config/set-user-config`, payload, {
        observe: "response",
      })
      .pipe(
        map((Response) => {
          return Response;
        }),
        catchError((errorRes) => {
          return throwError(errorRes);
        }),
      );
  }
}
